import { css } from '@emotion/react';

export default {
  flexWrapper: () =>
    css({
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
    }),
};
